<template>
  <div v-if="loading === true" class="s-center">
    <section class="onboarding__img s-to-center">
      <img
        src="https://res.cloudinary.com/iquela/image/upload/v1677042584/call-to-action/Work_time-pana_ezka5y.svg"
        alt="redireccion"
      />
    </section>
    <h1 class="comofunciona__titulo">Bienvenido a iQuela</h1>
    <p>Espera un momento, te estamos rediriendo a la paǵina principal</p>
  </div>

  <div v-else class="s-to-center">
    <navegacion></navegacion>
    <br />
    <!-- header -->
    <headerComponent
      titulo="¡Obtén un portafolio web 100% profesional sin un solo cliente!"
      parrafo="¡Demuestra tu talento construyendo un portafolio profesional sin clientes! ¡Empieza hoy con proyectos realistas para demostrar lo que sabes!"
      nombreImagen="https://res.cloudinary.com/iquela/image/upload/v1677040261/call-to-action/Design_community-pana_gy4nra.svg"
      nombreBoton="¡Quiero Empezar!"
      class="section__call-to-action"
    ></headerComponent>
    <br />
    <br />
    <!-- que es iQuela -->
    <h1 class="s-center comofunciona__titulo">¿Qué es iQuela?</h1>
    <p class="s-center comofunciona__parrafo">
      iQuela es una plataforma educativa enfocada en impulsar los conocimientos
      de diseñadores y programadores a través de la práctica con briefs que se asemejan a la realidad.
    </p>
    <br />
    <br />
    <!-- proyectos -->
    <h1 class="s-center comofunciona__titulo">Proyectos que puedes realizar</h1>
    <projectsComponent />
    <br /><br />
    <!-- como funciona -->
    <h1 class="s-center comofunciona__titulo">¿Cómo funciona iQuela?</h1>
    <functioniQuelaComponent />
    <br />
    <br />
    <br />
    <!-- la plataforma creada  -->
    <section class="ed-grid m-grid-2">
      <div class="s-left paraque__texto">
        <article>
          <h1 class="comofunciona__titulo">
            La plataforma creada para aprender mientras practicas
          </h1>
          <p>
            Aplica tus conocimientos y comienza a crear tu portafolio
            profesional con proyectos únicos
          </p>
          <Button
            class="boton-primario"
            label="Comenzar ahora"
            v-on:click.prevent="EnviarARegistro"
          />
        </article>
      </div>
      <div class="paraque__imagen">
        <img src="../img/imagenes-call-to-action/para-que.svg" alt="" />
      </div>
    </section>
    <!-- categorias -->
    <!-- <h1 class="s-center comofunciona__titulo">Practica por categorias</h1>
    <categoriesComponent />
    <br /> -->
    <!-- beneficios -->
    <h1 class="s-center comofunciona__titulo">
      Conoce los beneficios de practicar
    </h1>
    <benefitComponent />
    <br />
    <!-- proyectos publicos  -->
    <section class="ed-grid m-grid-2">
      <div class="paraque__imagen">
        <img
          src="https://res.cloudinary.com/iquela/image/upload/v1677041236/call-to-action/Scrum_board-amico_hd1wcx.svg"
          alt="public"
        />
      </div>
      <div class="s-left paraque__texto">
        <article>
          <h1 class="comofunciona__titulo">
            Todos los proyectos en iQuela son públicos
          </h1>
          <p>
            Buscamos que tus proyectos, al igual que los nuestros, estén libres
            para que todos puedan utilizar y crear proyectos completos, desde el
            UX hasta el despliegue en servidores.
          </p>
        </article>
      </div>
    </section>
    <!-- areas -->
    <h1 class="s-center comofunciona__titulo">
      Descubre cómo otras áreas en tecnología utilizarán tus proyectos
    </h1>
    <areasComponent />
    <br /><br />

    <!-- lista de beneficios -->
    <section class="s-center">
      <h1 class="comofunciona__titulo">
        Beneficios de tener tu proyecto público
      </h1>
      <div class="ed-grid s-grid-2 beneficios s-to-center">
        <section class="card">
          <ul class="beneficios_lista">
            <li>Créditos de autor cada vez que utilicen tu proyecto</li>
            <li>Gana puntos cada vez que alguien haga uso de tu trabajo</li>
            <li>
              Cononce y conecta con las personas que utilicen tus proyectos
            </li>
          </ul>
        </section>
        <section class="card">
          <ul class="beneficios_lista">
            <li>
              Sube de nivel en el ranking para que más personas te conozcan
            </li>
            <li>Crea una red de contactos para trabajar en equipo</li>
            <li>Tus proyectos ayudarán a las otras áreas de desarrollo</li>
            <li>
              Obtén briefs de proyectos para que puedas construir tu portafolio
              UI/UX/WEB profesional”
            </li>
          </ul>
        </section>
      </div>
    </section>

    <!-- call to action contenedor__final -->
    <Card class="ed-grid m-grid-2 s-to-center cardfinal">
      <template #header>
        <div class="card cardfinal__imagen">
          <img
            src="https://res.cloudinary.com/iquela/image/upload/v1677039471/call-to-action/formulario_ojugme.svg"
            alt="cta"
          />
        </div>
      </template>
      <template #content>
        <div class="card">
          <div class="cardfinal__texto s-center s-center">
            <h1 class="cardfinal__texto--h1">¡Regístrate gratis!</h1>
            <p>
              La práctica es la mejor manera de aprender, accede a todos los
              desafíos que hay en iQuela.
            </p>
            <Button
              class="boton-primario"
              label="Quiero registrarme"
              v-on:click.prevent="EnviarARegistro"
            />
          </div>
        </div>
      </template>
    </Card>
    <br />
    <i-q-footer></i-q-footer>
  </div>
</template>

<script>
import navegacion from "../components/iQuelaNav.vue";
import iQFooter from "../components/iQuelaFooter.vue";
import Card from "primevue/card";
import Button from "primevue/button";
import headerComponent from "../components/home/headerComponent.vue";
import projectsComponent from "../components/iQuelaCard.vue";
import functioniQuelaComponent from "../components/home/functioniQuelaComponent.vue";
import categoriesComponent from "../components/home/categoriesComponent.vue";
import benefitComponent from "../components/home/benefitComponent.vue";
import areasComponent from "../components/home/areasComponent.vue";

import router from "../router";
import { ref } from "vue";
import store from "../store";
import { useStore } from "vuex";
export default {
  setup() {
    const Store = useStore();
    let loading = ref(true);
    if (localStorage.getItem("jwt")) {
      loading.value = false;
    }
    setTimeout(() => {
      loading.value = false;
      localStorage.setItem(
        "jwt",
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c"
      );
    }, 3000);

    const EnviarARegistro = () => {
      router.push({ name: "registro" });
    };
    return {
      /* funciones */
      EnviarARegistro,
      /* variables */
      loading,
    };
  },
  components: {
    /* home */
    headerComponent,
    projectsComponent,
    functioniQuelaComponent,
    categoriesComponent,
    benefitComponent,
    areasComponent,
    /*  */
    navegacion,
    iQFooter,
    /* primevue */
    Button,
    Card,
  },
};
</script>

<style lang="scss" scoped>
@import "../sass/home.scss";
.boton-primario {
  width: 240px;
}
</style> 